import { LogoRound } from "../../assets/LandingImages/LogoRound"

function Contact() {
    return(
        <div id="contact-us" className="contact flex flex-col justify-center gap-6 px-10 bg-blue-500 text-white py-3 ">
            <div className="contact flex-col md:flex-row justify-center gap-6 sm:gap-8 px-10 -mt-8">
                <label className="-mr-6"><LogoRound /></label>
                <div className="max-w-md">
                    <p>
                        Directorate of Technical Education proposes an Industry-Academia-Government-Conclave to be held in 2024 focusing on 8 out of 17 UN Sustainable Development Goals (SDGs).
                    </p>
                </div>
                <div>
                    <label>Quick Links</label>
                    <p><a href="/">Home</a></p>
                    <p><a href="/login">Sign In</a></p>
                    <p>
                        <a href="https://www.dtekerala.gov.in/" rel="noreferrer" target="_blank">DTE</a>
                    </p>
                </div>
                <div>
                    <label>Contact Us</label>
                    <p>
                        <a href="mailto:udyamadte@gmail.com">Email : udyamadte@gmail.com</a>
                    </p>
                    <p>Phone : 9074018850, 9880166402, 9020608727</p>
                </div>
            </div>
            <div className="text-center -mt-6"> {/* New "Developed By" Section */}
                <p>
                    Developed By: <a href="/developers" className="underline">gecteachlabs</a>
                </p>
            </div>
        </div>
    );
}

export default Contact